import classNames from "classnames/dedupe";
import type { WithMetadata } from "../../pages";
import { AgentReferralReasons } from "./AgentReferralReasons";
import { AgentReferralText } from "./AgentReferralText";
import type {
  AgentReferralProps,
  AgentReferralReasonsProps,
  AgentReferralTextProps,
} from "./types";

export const AgentReferral = ({
  ref,
  ...props
}: WithMetadata<AgentReferralProps>) => {
  const { className, componentName, ...otherProps } = props;
  const { variant } = otherProps;

  const classes = classNames("mobius", "mobius-agent-referral", className);

  return (
    <div
      ref={ref}
      {...(componentName ? { "data-component": componentName } : {})}
      {...(variant ? { "data-variant": variant } : {})}
      className={classes}
    >
      {variant === "referral-reasons" ? (
        <AgentReferralReasons {...(otherProps as AgentReferralReasonsProps)} />
      ) : (
        <AgentReferralText {...(otherProps as AgentReferralTextProps)} />
      )}
    </div>
  );
};

AgentReferral.displayName = "AgentReferral";
